<!--
 * @Description: 渠道级联组件
 * @Author: mdb
 * @Date: 2022-07-10 21:17:52
 * @LastEditTime: 2023-04-18 19:01:54
 * @LastEditors: mdb
-->
<template>
  <Cascader
    v-bind="$attrs"
    :appId="appId"
    :paramCode="paramCode"
    :options="treeOptions"
    :fieldNames="{ label: eumns[shareInfo.language], value: 'id' }"
    :placeholder="$t('common.pleaseSelect')"
    change-on-select
    allowClear
  />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { listByParamCodes } from '@/api/common'
import Cascader from '../index.vue'
import { paramCodesDataFilter } from '@/utils/index'
import { useInteractionStore } from '@/stores/interaction'
import type { ParamCodeItem } from '@/typings/common'
const shareInfo = useInteractionStore()
const props = defineProps<{
  appId?: 'cos_fbu' | 'cos_ofbu' | 'cos_lbu' | 'cos_zbu'
  paramCode?: string
  options?: ParamCodeItem[]
  status?: 0 | 1 // 业务参数状态【0-可用,1-禁用】
}>()
const eumns = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}
const treeOptions = ref<ParamCodeItem[]>([])
const fetch = () => {
  if (props.appId && props.paramCode) {
    listByParamCodes({
      appId: props.appId,
      paramCodes: [props.paramCode]
    }).then((res) => {
      if (props.status != null) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, props.status)
      }
      treeOptions.value = props.paramCode && res.data?.[props.paramCode]
    })
  }
}

watch(
  () => props.options,
  () => {
    if (typeof props.options !== 'undefined') {
      treeOptions.value =
        props.status != null ? paramCodesDataFilter({ paramKey: props.options }, props.status)?.paramKey : props.options
    } else {
      fetch()
    }
  },
  { immediate: true }
)
</script>
<script lang="ts">
export default { name: 'ParamCodeCascader' }
</script>

<style scoped></style>
